module.exports = __webpack_public_path__ + "share.bca670ef.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/share.png
// module id = 347
// module chunks = 0